import { Component, Inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-popup-confirmacion',
    templateUrl: './popup-confirmacion.component.html',
    styleUrls: ['./popup-confirmacion.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupConfirmacionComponent {

  constructor(
    public dialogRef: MatDialogRef<PopupConfirmacionComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any) { }

  @Input() title = '¿Está seguro de que desea eliminar?';
  @Input() msg = 'Esta acción no puede deshacerse.';

  confirmarEliminacion() {
    this.dialogRef.close(true);  // Confirma la eliminación
  }

  cancelarEliminacion() {
    this.dialogRef.close(false); // Cancela la eliminación
  }
}
